module.exports = __webpack_public_path__ + "static/bg-banner-cl-offer-a4a1d6ffa3e595f800e1f32e9e8383b2.png";